<template>
 
 <section id="portfolio" class="py-5 ">
      <div class="container">
        <div class="shadow-lg p-3 mb-5 bg-body-tertiary rounded">
        <h2 class="mb-0">Diplômes et Formations</h2></div>

        <h3 class="fw-light fs-5">mon parcours scolaires</h3>
        <div class="row gy-4 gy-md-0 mt-4 ">
            <div class="card-group h-100 ">
                <div class="card p-2">
                    <img src="../assets/th1.png" class="rounded float-start card-img-top" alt="..." width="474" height="237">
                    <div class="card-body">
                    <h5 class="card-title">Lycée ex CEM Mbacke 2 </h5>
                    <p class="card-text">Baccalauréat, mention Bien, S2</p>
                    <p class="card-text"><small class="text-muted">2017-2018</small></p>
                    </div>
                </div>
                <br><br>
                <div class="card p-2">
                    <img src="../assets/th.png" class="card-img-top rounded float-start" alt="..." width="474" height="237">
                    <div class="card-body">
                    <h5 class="card-title">Ecole Supérieure Polytechnique de Dakar</h5>
                    <p class="card-text">DUT ( Diplôme Universitaire de Technologie en informatique).</p>
                    <p class="card-text"><small class="text-muted">2018-2020</small></p>
                    </div>
                </div>
                <br><br>
                <div class="card p-2">
                    <img src="../assets/th2.png" class="card-img-top rounded float-start" alt="..." width="474" height="237">
                    <div class="card-body">
                    <h5 class="card-title">Université du littoral Côte d'Opale de Calais</h5>
                    <p class="card-text">Diplôme d'ingénieurs en developpement et data science </p>
                    <p class="card-text"><small class="text-muted">Depuis 2021</small></p>
                    </div>
                </div>
            </div>
                            
        </div>
      </div>
  </section>
</template>

<script>

export default ({
   name:'CourseView'
})
</script>
<style scoped>

</style>